import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M7 12a5 5 0 1 0 5 -5","key":"svg-1"}],["path",{"d":"M6.29 18.957a9 9 0 1 0 5.71 -15.957","key":"svg-2"}]]

const IconChartArcs3 = createReactComponent('outline', 'chart-arcs-3', 'ChartArcs3', __iconNode);

export default IconChartArcs3;